function fixHeaderPositionOnScroll() {
  const mainHeader = document.querySelector('#mainHeader')
  
  window.addEventListener('scroll', () => {
    let scrollYPosition = window.scrollY
    if(scrollYPosition > 5) {
      mainHeader.style.top = '0px';
      mainHeader.style.height = 'unset';
      mainHeader.classList.add('bg-white');
      mainHeader.classList.remove('bg-transparent')
    }
  });
}

function moveFrontVideoGallery() {
  const videoContainer = document.querySelector('.pfdm-video-gallery-container')
  const otherVideos = document.querySelector('.pfdm-video-gallery-items-container')
  const video = document.querySelector('.pfdm-video-gallery-container iframe')
  const element = document.createElement('div')
  element.classList.add('video-overlay-click')
  if(videoContainer) {
    videoContainer.insertAdjacentElement('afterbegin', element)
  }
 
  document.addEventListener('click', function(e) {
    if(e.target !== video && e.target !== element) {
      video.classList.remove('active')
      otherVideos.classList.remove('inactive')
    }
  })

  element.addEventListener('click', function() {
    video.classList.add('active')
    otherVideos.classList.add('inactive')
  })
}


addEventListener('DOMContentLoaded', (event) => {
  fixHeaderPositionOnScroll();
  moveFrontVideoGallery()

  const textBalancer = (function () {
  
    var candidates = [];

    /* pass in a string of selectors to be balanced.
    // if you didnt specify any, thats ok! We'll just
    // balance anything with the balance-text class */
    var initialize = function (selectors) {

        if (!selectors) {
            candidates = document.querySelectorAll('.balance-text');
        } else {
            createSelectors(selectors);
        }

        balanceText();

        var rebalanceText = debounce(function() {
            balanceText();
        }, 100);

        window.addEventListener('resize', rebalanceText);
    }

    /* HELPER FUNCTION -- initializes recursive binary search */
    var balanceText = function () {
        var element;
        var i;

        for (i = 0; i < candidates.length; i += 1) {
            element = candidates[i];
      var textAlignment = getComputedStyle(element).textAlign;
      
            if (textElementIsMultipleLines(element)) {
                element.style.maxWidth = '';
                squeezeContainer(element, element.clientHeight, 0, element.clientWidth);
            }
      if (textAlignment == 'center') {
        element.style.marginLeft = 'auto';
        element.style.marginRight = 'auto';
      } else if (textAlignment == 'right') {
        element.style.marginLeft = 'auto';
      }

        }

    }

    /* Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing. */
    var debounce = function (func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    /* Make the headline element as narrow as possible while maintaining its current height (number of lines). Binary search. */
    function squeezeContainer(headline, originalHeight, bottomRange, topRange) {
        var mid;
        if (bottomRange >= topRange) {
            headline.style.maxWidth = topRange + 'px';
            return;
        }
        mid = (bottomRange + topRange) / 2;
        headline.style.maxWidth = mid + 'px';

        if (headline.clientHeight > originalHeight) {
            /* we've squoze too far and headline has spilled onto an additional line; recurse on wider range */
            squeezeContainer(headline, originalHeight, mid+1, topRange);
        } else {
            /* headline has not wrapped to another line; keep squeezing! */
            squeezeContainer(headline, originalHeight, bottomRange+1, mid);
        }
    }

    /* this populates our candidates array with dom objects
    // that need to be balanced */
    var createSelectors = function(selectors) {
        selectorArray = selectors.split(',');
        for (var i = 0; i < selectorArray.length; i += 1) {
            var currentSelectorElements = document.querySelectorAll(selectorArray[i].trim());

            for (var j = 0; j < currentSelectorElements.length; j += 1) {
                var currentSelectorElement = currentSelectorElements[j];
                candidates.push(currentSelectorElement);
            }
        }
    }

    /* function to see if a headline is multiple lines
    // we only want to break if the headline is multiple lines
    //
    // We achieve this by turning the first word into a span
    // and then we compare the height of that span to the height
    // of the entire headline. If the headline is bigger than the
    // span by 10px we balance the headline. */
    var textElementIsMultipleLines = function (element) {
        var firstWordHeight;
        var elementHeight;
        var HEIGHT_OFFSET;
        var elementWords;
        var firstWord;
        var ORIGINAL_ELEMENT_TEXT;

        

        ORIGINAL_ELEMENT_TEXT = element.innerHTML;

        /* usually there is around a 5px discrepency between
        // the first word and the height of the whole headline
        // so subtract the height of the headline by 10 px and
        // we should be good */
        HEIGHT_OFFSET = 10;

        /* get all the words in the headline as
        // an array -- will include punctuation
        //
        // this is used to put the headline back together */
        elementWords = element.innerHTML.split(' ');

        /* make span for first word and give it an id
        // so we can access it in le dom */
        firstWord = document.createElement('span');
        firstWord.id = 'element-first-word';
        firstWord.innerHTML = elementWords[0];

        /* this is the entire headline
        // as an array except for first word
        //
        // we will append it to the headline after the span */
        elementWords = elementWords.slice(1);

        /* empty the headline and append the span to it */
        element.innerHTML = '';
        element.appendChild(firstWord);

        /* add the rest of the element back to it */
        element.innerHTML += ' ' + elementWords.join(' ');

        /* update the first word variable in the dom */
        firstWord = document.getElementById('element-first-word');
        

        firstWordHeight = firstWord.offsetHeight;
        
        elementHeight = element.offsetHeight;
        /* restore the original element text */
        element.innerHTML = ORIGINAL_ELEMENT_TEXT;

        /* compare the height of the element and the height of the first word */
        return elementHeight - HEIGHT_OFFSET > firstWordHeight;

    } /* end textElementIsMultipleLines */

    return {
        initialize: initialize,
    };

})(); /* end textBalancer */

textBalancer.initialize('main h1, main h2, main h3, h4, main p, .uagb-post__excerpt');
const resizeEvent = new Event('resize');
window.dispatchEvent(resizeEvent);
  
  /* image gallery */
(function ($) {
  let $imageGallery = $('.cmp-image-gallery');

  $imageGallery.each(function () {
    var $this = $(this);
    var $mainGallery = $this.find('.cmp-image-gallery__items');
    var $navGallery = $this.find('.cmp-image-gallery__nav-items');
	  var $navItems = 6;
    var slidesLength = 6;

    $mainGallery.on('init', function(event, slick){
	    slidesLength = slick.$slides.length;
      if(slidesLength > 6) {
        $navItems = 6;
      } else {
        $navItems = slidesLength - 1;
      }
    });

    $mainGallery.slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7000,
      asNavFor: $navGallery,
      vertical: false,
    });

    $navGallery.slick({
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7418 9.47314H1.92853C1.0413 9.47314 0.596986 8.35379 1.22434 7.69916L7.63095 1.014C8.01984 0.608198 8.65044 0.608198 9.03933 1.014L15.4459 7.69916C16.0733 8.35379 15.629 9.47314 14.7418 9.47314Z" fill="#B2A390"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0413 0.726807L1.95854 0.726807C0.84492 0.726807 0.287232 2.13178 1.07467 2.95346L9.11604 11.3445C9.60417 11.8538 10.3957 11.8538 10.8838 11.3445L18.9252 2.95346C19.7127 2.13178 19.1549 0.726807 18.0413 0.726807Z" fill="#B2A390"/></svg></button>',
      infinite:true,
      speed: 300,
      slidesToShow: $navItems,
      slidesToScroll: 1,
      asNavFor: $mainGallery,
      focusOnSelect: true,
      vertical:false,
	    verticalSwiping: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: $navItems >= 5 ? 5 : (slidesLength - 1),
          }
        },
        {
          breakpoint: 768,
          settings: {
            vertical:false,
            slidesToShow: $navItems >= 4 ? 4 : (slidesLength - 1)
          }
        }
      ]
    });
  });
})(jQuery);
});



